import React, { Component } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { withRouter } from "react-router-dom";
import { activateNonAuthLayout } from "../../store/actions";
import { connect } from "react-redux";

class Error extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.activateNonAuthLayout();
  }

  render() {
    return (
      <React.Fragment>
        <div className="account-pages my-5 pt-5">
          <div className="container">
            <Row className="justify-content-center">
              <Col md="8" lg="6" xl="5">
                <Card className="shadow-none overflow-hidden">
                  <CardBody>
                    <div className="text-center">
                      <h1 className="display-2 font-weight-normal mt-0">
                        {this.props.statusCode}
                      </h1>
                      <h4>{this.props.message}</h4>
                    </div>
                  </CardBody>
                  <div>
                    {/* <img src={error} alt="" className="img-fluid mx-auto d-block" /> */}
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  return {};
};

export default withRouter(
  connect(mapStatetoProps, { activateNonAuthLayout })(Error)
);
